import { useCallback, useState } from 'react';

/**
 * Sheet names reported by the Excel preview; `undefined` until it loads (empty once it fails or there is no workbook).
 * Keyed on the file id, not the presigned URL, which is re-signed on every refetch and would drop the names each time.
 */
export function useWorkbookSheetNames(
    presignedUrl: string | null,
    fileId: number,
) {
    const [loaded, setLoaded] = useState<{
        fileId: number;
        names: string[];
    } | null>(null);

    const onExcelSheetNames = useCallback(
        (names: string[]) => {
            if (presignedUrl) setLoaded({ fileId, names });
        },
        [presignedUrl, fileId],
    );

    const sheetNames =
        presignedUrl === null
            ? []
            : loaded?.fileId === fileId
              ? loaded.names
              : undefined;

    return { sheetNames, onExcelSheetNames };
}
